<template>
	<v-container grid-list-xs class="py-0 px-0">
		<v-layout row wrap class="px-2">
			<v-flex xs12>
				<div class="container--box mx-auto">
					<p class="display-1 mb-0">
						{{ $t("title.restaurants") }}
					</p>
					<small>More places to stay in Miami Beach</small>
				</div>
			</v-flex>
		</v-layout>
		<v-sheet class="mx-auto" color="transparent">
			<v-slide-group
				v-model="model"
				class="pa-4"
				center-active
				prev-icon="mdi-arrow-left-bold-circle-outline"
				next-icon="mdi-arrow-right-bold-circle-outline"
				show-arrows
				color="primary"
			>
				<v-slide-item
					v-for="(item, index) in restaurants"
					:key="index"
					v-slot="{ active, toggle }"
					color="primary"
				>
					<v-hover v-slot="{ hover }">
						<v-card
							:elevation="hover ? 12 : 2"
							:class="{ 'on-hover': hover }"
							:color="active ? 'primary' : 'white'"
							class="ma-4"
							height="auto"
							:width="minWidth"
							@click="toggle"
							tile
						>
							<v-img
								:src="
									item && item.image_url
										? item.image_url
										: image_placeholder
								"
								:width="minWidth"
								max-height="200px"
							>
							</v-img>

							<v-card-title primary-title>
								<v-spacer></v-spacer>
								{{ item.name }}
								<v-spacer></v-spacer>
							</v-card-title>
							<v-card-subtitle
								style="
									overflow: hidden;
									max-width: 400px;
									display: -webkit-box;
									-webkit-line-clamp: 2;
									-webkit-box-orient: vertical;
									margin: 10px auto;
								"
								v-html="item.tenant_description"
							>
							</v-card-subtitle>
						</v-card>
					</v-hover>
				</v-slide-item>
			</v-slide-group>
		</v-sheet>
	</v-container>
</template>

<script>
	export default {
		props: ["restaurants", "image_placeholder"],
		data() {
			return {
				model: null,
			};
		},
		computed: {
			minHeight() {
				const height = this.$vuetify.breakpoint.mdAndUp ? "350px" : "150px";

				return `calc(${height} - ${this.$vuetify.application.top}px)`;
			},
			minWidth() {
				const width = this.$vuetify.breakpoint.mdAndUp ? "300px" : "260px";

				return `calc(${width} - ${this.$vuetify.application.top}px)`;
			},
		},
	};
</script>

<style scoped>
.v-card {
	transition: opacity 0.4s ease-in-out;
	opacity: 0.8;
}

.v-card:not(.on-hover) {
	opacity: 1;
}

.show-btns {
	color: rgba(255, 255, 255, 1) !important;
}
.v-icon .v-icon {
	font-size: 75px !important;
	color: blue !important;
}
</style>